import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tableInformeGerencialView.
 * @extends JetView
 */
export default class tableInformeGerencialView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The layout configuration.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'treetable', // Treetable component
                            id: 'treetable', // Unique identifier for the treetable
                            css: 'webix_header_border webix_data_border webix_footer_border informeGerencial', // CSS classes for styling
                            select: true, // Enable row selection
                            height: 0, // Initial height
                            autoConfig: true, // Automatically configure columns
                            columns: [], // Columns configuration
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        grid = $$('treetable'); // Get the treetable instance
        this.on(this.app, 'flujoCajaResumido:filter', (filterData) => {
            // Event listener for filtering data
            var object = Object.entries(filterData); // Convert filterData to an array of entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append to query string
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object values
                        if (object[i][0] === 'Date') {
                            // If the key is 'Date'
                            var d = new Date(object[i][1]); // Create a date object
                            var dateFrom =
                                'DateFrom=' +
                                d.getFullYear() +
                                '-' +
                                ('00' + (d.getMonth() + 1)).slice(-2) +
                                '-' +
                                '01'; // Format date for query
                            string1 = string1 + '&' + dateFrom; // Append to query string
                        } else {
                            if (object[i][0] === 'Date2') {
                                // If the key is 'Date2'
                                var d = new Date(object[i][1]); // Create a date object
                                var ud = new Date(object[i][1].getFullYear(), object[i][1].getMonth() + 1, 0); // Get last day of the month
                                var dateFrom =
                                    'DateTo=' +
                                    d.getFullYear() +
                                    '-' +
                                    ('00' + (d.getMonth() + 1)).slice(-2) +
                                    '-' +
                                    ('00' + ud.getDate()).slice(-2); // Format date for query
                                string1 = string1 + '&' + dateFrom; // Append to query string
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Report=2'; // Append report parameter
            webix
                .ajax() // AJAX request to fetch data
                .headers({
                    'Content-type': 'application/json', // Set content type
                })
                .get(
                    devConfig.geturlApi() + // API URL
                        'Financial/GetControlFiscal?' +
                        string1, // Query string
                    {
                        success: function (text, data, XmlHttpRequest) {
                            // Success callback
                            var resp = JSON.parse(text); // Parse response
                            grid.clearAll(); // Clear existing grid data
                            grid.config.columns = [];
                            grid.refreshColumns();
                            if (
                                !resp.HasError && // Check for errors
                                resp.Data != undefined &&
                                resp.Data.Columns != undefined &&
                                resp.Data.Columns.length > 0 // Ensure data is present
                            ) {
                                grid.parse(resp.Data.Columns); // Populate grid with new data
                                for (var i in grid.config.columns) {
                                    // Disable sorting for columns
                                    grid.config.columns[i].sort = false;
                                    grid.adjustColumn(
                                        grid.config.columns[i].id,
                                        'all', // Adjust column width
                                    );
                                }
                                grid.attachEvent(
                                    'onResize', // Attach resize event
                                    function (width, height) {
                                        for (var i in grid.config.columns) {
                                            grid.adjustColumn(
                                                grid.config.columns[i].id,
                                                'all', // Adjust column width on resize
                                            );
                                        }
                                    },
                                );
                            }
                        },
                    },
                );
            $$('filterPopup').hide(); // Hide filter popup
        });
    }
}

// FILE DOCUMENTED
